export default {"src":"/_next/static/media/vertical-dashed-line.204a188a.svg","height":107,"width":18};